import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bsmartSchool", "contractCode", "report"];

  connect() {
    this.syncContractField();
  }

  syncContractField() {
    if (!this.hasBsmartSchoolTarget || !this.hasContractCodeTarget) return;

    const enabled = this.bsmartSchoolTarget.checked;
    this.contractCodeTarget.disabled = !enabled;
    this.contractCodeTarget.required = enabled;
  }

  clearReport() {
    if (this.hasReportTarget) {
      this.reportTarget.innerHTML = "";
      return;
    }

    const fallback = document.getElementById("report");
    if (fallback) fallback.innerHTML = "";
  }
}
